import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/AccessTime.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/BusinessCenter.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/@mui/icons-material/EditCalendar.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Breadcrumbs/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Grid/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Paper/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Skeleton/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Slide/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Stack/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ApplicationSuccess/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BlogCard/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Icons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/NextImage/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/NextLink/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Pagination/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ProductCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/SectionContainer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Table/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Toastify/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-detail/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-detail/info-product.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-detail/product-in-store.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/product-list/relative-product.tsx");
